/* VANTO full-screen navigation controller. Original code. */
(()=>{
  const q=(s,c=document)=>c.querySelector(s),qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const overlay=q('[data-menu-drawer]');
  const triggers=qa('[data-menu-open]');
  const trigger=triggers[0];
  if(!overlay||!trigger)return;

  const levels=qa('[data-nav-level]',overlay);
  const levelById=id=>levels.find(l=>l.dataset.navLevel===id);
  let stack=['root'],returnTrigger=trigger;
  const reduceMotion=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const showLevel=id=>{
    levels.forEach(l=>l.setAttribute('aria-hidden', l.dataset.navLevel===id ? 'false' : 'true'));
    const active=levelById(id);
    const focusTarget=active && q('.nav-back,.nav-link',active);
    if(focusTarget)requestAnimationFrame(()=>focusTarget.focus());
  };

  const openMenu=()=>{
    stack=['root'];
    showLevel('root');
    overlay.setAttribute('aria-hidden','false');
    triggers.forEach(item=>item.setAttribute('aria-expanded','true'));
    document.body.classList.add('drawer-open');
    // mutual exclusion: close cart if open
    const cart=q('[data-cart-drawer]');
    if(cart && cart.getAttribute('aria-hidden')==='false'){cart.setAttribute('aria-hidden','true')}
    const search=q('[data-search-overlay]');
    if(search && search.getAttribute('aria-hidden')==='false'){search.setAttribute('aria-hidden','true');qa('[data-search-open]').forEach(item=>item.setAttribute('aria-expanded','false'))}
    requestAnimationFrame(()=>q('.nav-close',overlay)?.focus());
  };
  const closeMenu=()=>{
    overlay.setAttribute('aria-hidden','true');
    triggers.forEach(item=>item.setAttribute('aria-expanded','false'));
    document.body.classList.remove('drawer-open');
    stack=['root'];
    showLevel('root');
    returnTrigger.focus();
  };

  triggers.forEach(item=>item.addEventListener('click',()=>{returnTrigger=item;overlay.getAttribute('aria-hidden')==='false'?closeMenu():openMenu()}));
  qa('[data-menu-close]',overlay).forEach(btn=>btn.addEventListener('click',closeMenu));

  overlay.addEventListener('click',e=>{
    const openBtn=e.target.closest('[data-nav-open-level]');
    if(openBtn){
      const targetId=openBtn.dataset.navOpenLevel;
      if(levelById(targetId)){
        stack.push(targetId);
        showLevel(targetId);
      }
      return;
    }
    const backBtn=e.target.closest('[data-nav-back]');
    if(backBtn){
      if(stack.length>1)stack.pop();
      showLevel(stack[stack.length-1]);
    }
  });

  document.addEventListener('keydown',e=>{
    if(e.key!=='Escape')return;
    if(overlay.getAttribute('aria-hidden')!=='false')return;
    if(stack.length>1){stack.pop();showLevel(stack[stack.length-1])}
    else closeMenu();
  });

  // focus trap
  overlay.addEventListener('keydown',e=>{
    if(e.key!=='Tab')return;
    const active=levels.find(l=>l.getAttribute('aria-hidden')==='false');
    const focusable=qa('button,a[href]',overlay).filter(el=>{
      if(active && !active.contains(el) && el.closest('[data-nav-level]'))return false;
      return el.offsetParent!==null || el===q('.nav-close',overlay);
    });
    if(!focusable.length)return;
    const first=focusable[0],last=focusable[focusable.length-1];
    if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus()}
    else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus()}
  });
})();
